export default __webpack_public_path__ + "static/bg-mesquita-m-6a9fcab716514f51b5ff5e8671a192a0.png";